import { useState, useEffect } from 'react'

const __version = "______42"

export default function PublicLayout() {
  const [currentPage, setCurrentPage] = useState(`quemsomos.html?v=${__version}`)
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [areaClienteOpen, setAreaClienteOpen] = useState(false)

  useEffect(() => {
    const sidebarCollapse = document.getElementById('sidebarCollapse')
    
    if (sidebarCollapse) {
      const handleClick = () => {
        setSidebarOpen(!sidebarOpen)
      }
      
      sidebarCollapse.addEventListener('click', handleClick)
      
      return () => {
        sidebarCollapse.removeEventListener('click', handleClick)
      }
    }
  }, [sidebarOpen])

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar" style={{ display: sidebarOpen ? 'block' : 'none', width: sidebarOpen ? 'auto' : '0' }}>
        <div className="p-4 pt-4">
          <a href={`/`} className="logo">
            <img 
              alt="Mainengine Consultoria em Sistemas" 
              src="/images/logomainengine.jpg" 
              width="173" 
              height="43" 
            />
          </a>
          <ul className="list-unstyled components mb-5">
            <li>
              <a 
                href={`quemsomos.html?v=${__version}`}
                target="eng_frame_conteudo"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentPage(`quemsomos.html?v=${__version}`)
                }}
              >
                <i className='fa fa-home' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Quem Somos
              </a>
            </li>
            <li>
              <a 
                href={`servicos.html?v=${__version}`}
                target="eng_frame_conteudo"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentPage(`servicos.html?v=${__version}`)
                }}
              >
                <i className='fa fa-gear' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Serviços
              </a>
            </li>
            <li>
              <a 
                href={`produtos.html?v=${__version}`}
                target="eng_frame_conteudo"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentPage(`produtos.html?v=${__version}`)
                }}
              >
                <i className='fa fa-cubes' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Produtos
              </a>
            </li>
            <li>
              <a 
                href={`tecnologia.html?v=${__version}`}
                target="eng_frame_conteudo"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentPage(`tecnologia.html?v=${__version}`)
                }}
              >
                <i className='fa fa-superscript' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Tecnologia
              </a>
            </li>
            <li>
              <a 
                href={`clientes.html?v=${__version}`}
                target="eng_frame_conteudo"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentPage(`clientes.html?v=${__version}`)
                }}
              >
                <i className='fa fa-group' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Nossos Clientes
              </a>
            </li>
            <li>
              <a 
                href={`contato.html?v=${__version}`}
                target="eng_frame_conteudo"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentPage(`contato.html?v=${__version}`)
                }}
              >
                <i className='fa fa-comments' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Contato
              </a>
            </li>
            <li>
              <a 
                href="#sistemaSubmenuAreaCliente" 
                onClick={(e) => {
                  e.preventDefault()
                  setAreaClienteOpen(!areaClienteOpen)
                }}
                aria-expanded={areaClienteOpen}
                className="dropdown-toggle"
              >
                <i className='fa fa-wpforms' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                Área para Clientes
              </a>
              <ul className={`list-unstyled ${areaClienteOpen ? 'show' : 'collapse'}`} id="sistemaSubmenuAreaCliente">
                <li>
                  <a 
                    href={`em-desenvolvimento.html?v=${__version}`}
                    target="eng_frame_conteudo"
                    onClick={(e) => {
                      e.preventDefault()
                      setCurrentPage(`em-desenvolvimento.html?v=${__version}`)
                    }}
                  >
                    <i className='fa fa-gears' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                    Painel de Processamentos
                  </a>
                </li>
                <li>
                  <a 
                    href={`em-desenvolvimento.html?v=${__version}`}
                    target="eng_frame_conteudo"
                    onClick={(e) => {
                      e.preventDefault()
                      setCurrentPage(`em-desenvolvimento.html?v=${__version}`)
                    }}
                  >
                    <i className='fa fa-unlock' aria-hidden='true' style={{ paddingRight: '3px' }}></i>
                    Controle de Acessos
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <div className="footer">
            <p>&copy; Copyright 1997-{new Date().getFullYear()} MainEngine®</p>
          </div>
        </div>
      </nav>

      <nav style={{ height: '100vh', width: '100%', overflowY: 'hidden', overflowX: 'hidden', zIndex: 999 }}>
        <div style={{ float: 'left', position: 'absolute', zIndex: 1000, paddingTop: '1.2em', paddingLeft: '0.6em' }}>
          <button type="button" id="sidebarCollapse" className="btn btn-primary">
            <i className="fa fa-bars"></i>
            <span className="sr-only">Menu</span>
          </button>
        </div>
        <iframe 
          src={currentPage}
          id="eng_frame_conteudo" 
          name="eng_frame_conteudo" 
          style={{ border: 0, marginTop: '47px', height: 'inherit', width: 'inherit' }}
          title="Conteúdo"
          key={currentPage}
        />
      </nav>
    </div>
  )
}
